// extracted by mini-css-extract-plugin
export default {"wrap":"wrap-Qx8h","preloader":"preloader-IRYZ","fadeIn":"fadeIn-xTqS","image":"image-LAVC","list":"list-E0EE","simple":"simple-Dh4f","grid":"grid-ow0F","masonry":"masonry-svdT"};